export const ObjectLockTooltip = () => (
  <>
    When enabled, S3{" "}
    <a
      href="https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-lock.html"
      target="_blank"
    >
      Object Lock
    </a>{" "}
    becomes available on this bucket, allowing writers and owners to apply WORM
    (Write Once, Read Many) retention to objects. Enabling it does not lock any
    objects by itself. <strong>This setting is irreversible</strong> — once
    enabled, Object Lock cannot be disabled.
  </>
);
